/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

// @ts-ignore
import type { Dropdown } from 'ember-basic-dropdown/components/basic-dropdown';
export interface BvPopoverBodySignature {
  Args: {
    flush?: boolean;
    popover?: Dropdown;
    scrollable?: boolean;
  };
  Blocks: {
    default: [popover?: Dropdown];
  };
  Element: HTMLDivElement;
}

const BvPopoverBodyComponent = templateOnlyComponent<BvPopoverBodySignature>();

export default BvPopoverBodyComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvPopover::Body': typeof BvPopoverBodyComponent;
    'bv-popover/body': typeof BvPopoverBodyComponent;
  }
}
